<template>
  <div>
    <v-overlay
      :value="isLoading"
      class="d-flex align-center justify-center"
    >
      <v-progress-circular
        indeterminate
        size="64"
        color="primary"
      ></v-progress-circular>
    </v-overlay>
    <v-data-table
      dense
      disable-pagination
      hide-default-footer
      :loading="loadingTable"
      :headers="headers"
      :items="averageRates"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Relatório de Diária Média</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-menu :offset-y="true">
            <template v-slot:activator="{ on: menu, attrs }">
              <v-tooltip top>
                <template v-slot:activator="{ on: tooltip }">
                  <v-btn
                    color="primary"
                    outlined
                    icon
                    large
                    v-bind="attrs"
                    v-on="{ ...tooltip, ...menu }"
                  >
                    <v-icon>
                      {{ icons.mdiTools }}
                    </v-icon>
                  </v-btn>
                </template>
                <span>Ferramentas</span>
              </v-tooltip>
            </template>
            <v-list>
              <v-list-item @click="sendExportPdf()">
                <v-list-item-title>
                  <v-icon>{{ icons.mdiFilePdfBox }}</v-icon> Exportar PDF
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                icon
                small
                outlined
                large
                class="ml-2"
                color="primary"
                v-on="on"
                @click="sendExportPdf()"
              >
                <v-icon>{{ icons.mdiPrinter }}</v-icon>
              </v-btn>
            </template>
            <span>Imprimir</span>
          </v-tooltip>
          <v-badge
            :content="bagFilter"
            :value="bagFilter"
            bordered
            color="error"
            overlap
          >
            <v-btn
              class="ml-2"
              color="primary"
              outlined
              rounded
              @click="dialogFilter = true"
            >
              <v-icon>{{ icons.mdiFilter }}</v-icon>Filtros
            </v-btn>
          </v-badge>
          <v-spacer></v-spacer>
          <span>Periodo: de &nbsp <b style="color:black">{{ formatDate(filter.date_start) }}</b>&nbsp até &nbsp <b
            style="color:black"
          >{{ formatDate(filter.date_end) }}</b></span>
        </v-toolbar>
      </template>

      <!-- Formatar valores monetários para cada categoria -->
      <template
        v-for="category in categories"
        v-slot:[`item.${category}`]="{ item }"
      >
        <v-tooltip
          :key="category"
          top
        >
          <template v-slot:activator="{ on, attrs }">
            <span
              v-bind="attrs"
              v-on="on"
            >
              R$ {{ formatMoney(item[category]) }}<sup class="ml-1">({{ item[category + '_count'] }})</sup>
            </span>
          </template>
          <span>Número de diárias: {{ item[category + '_count'] }}</span>
        </v-tooltip>
      </template>

      <!-- Formatar média geral -->
      <template v-slot:item.general="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <span
              class="font-weight-bold"
              v-bind="attrs"
              v-on="on"
            >
              R$ {{ formatMoney(item.general) }}<sup class="ml-1">({{ item.general_count }})</sup>
            </span>
          </template>
          <span>Número de diárias: {{ item.general_count }}</span>
        </v-tooltip>
      </template>

      <template v-slot:foot>
        <tr style="height:44px; background:#fafafa">
          <td style="border-top:solid 1px #e4e3e6;padding-left:16px;padding-right:16px">
            <b>DIÁRIA MÉDIA DO PERÍODO:</b>
          </td>
          <td
            v-for="category in categories"
            :key="category"
            class="text-right"
            style="border-top:solid 1px #e4e3e6;padding-left:16px;padding-right:16px"
          >
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <span
                  v-bind="attrs"
                  v-on="on"
                >
                  R$ {{ formatMoney(categoryAverages[category]) }}<sup class="ml-1">({{ categoryCounts[category] }})</sup>
                </span>
              </template>
              <span>Número de diárias: {{ categoryCounts[category] }}</span>
            </v-tooltip>
          </td>
          <td
            class="text-right font-weight-bold"
            style="border-top:solid 1px #e4e3e6;padding-left:16px;padding-right:16px"
          >
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <span
                  v-bind="attrs"
                  v-on="on"
                >
                  R$ {{ formatMoney(generalAverage) }}<sup class="ml-1">({{ generalCount }})</sup>
                </span>
              </template>
              <span>Número de diárias: {{ generalCount }}</span>
            </v-tooltip>
          </td>
        </tr>
      </template>

      <template v-slot:no-data>
        <NoDataTable></NoDataTable>
      </template>
      <template v-slot:loading>
        Carregando...
      </template>
    </v-data-table>

    <!-- DIALOG FILTER -->
    <v-dialog
      v-model="dialogFilter"
      width="700px"
    >
      <v-card>
        <BarTitleDialog
          title="Filtros"
          @close="dialogFilter = false"
        />
        <v-card-text>
          <v-row>
            <v-col>
              <v-card outlined>
                <v-card-text>
                  <v-row no-gutters>
                    <v-col>
                      <v-text-field
                        v-model="filter.date_start"
                        :error-messages="error.date_start"
                        outlined
                        label="Data inicial"
                        type="date"
                        @change="error.date_start = null"
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field
                        v-model="filter.date_end"
                        class="ml-2"
                        :error-messages="error.date_end"
                        outlined
                        label="Data final"
                        type="date"
                        @change="error.date_end = null"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row>
            <v-col class="text-left">
              <v-btn
                text
                color="error"
                x-large
                @click="clearFilter()"
              >
                limpar filtros
              </v-btn>
            </v-col>

            <v-col class="text-right">
              <v-btn
                text
                color="secondary"
                x-large
                @click="dialogFilter = false"
              >
                FECHAR
              </v-btn>
              <v-btn
                :loading="loadingFilter"
                :disabled="loadingFilter"
                color="primary"
                class="ml-2"
                x-large
                @click="confirmFilter()"
              >
                aplicar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  mdiClose, mdiTools, mdiFileExcelOutline, mdiFilter, mdiPrinter, mdiFilePdfBox,
} from '@mdi/js'
import { mapActions } from 'vuex'
import NoDataTable from '@/components/NoDataTable.vue'
import BarTitleDialog from '@/components/BarTitleDialog.vue'

export default {
  components: {
    NoDataTable,
    BarTitleDialog,
  },
  data: () => ({
    // DIALOG FILTER
    dialogFilter: false,
    date_max: new Date().toISOString().slice(0, 10),
    filter: {},
    loadingFilter: false,
    categories: [],
    categoryAverages: {},
    categoryCounts: {},
    loadingTable: false,
    loading: false,
    isLoading: false,
    generalAverage: 0,
    generalCount: 0,
    headers: [],
    averageRates: [],
    icons: {
      mdiTools,
      mdiClose,
      mdiFileExcelOutline,
      mdiFilter,
      mdiPrinter,
      mdiFilePdfBox,
    },
    error: {
      date_start: null,
      date_end: null,
    },
  }),

  computed: {
    bagFilter() {
      return Object.keys(this.filter).length
    },
  },

  watch: {
    options: {
      handler() {
        this.initialize()
      },
    },
  },

  created() {
    this.periodInitial()
    this.initialize()
  },

  methods: {
    ...mapActions('average_rate_report', ['getAll', 'exportPdf']),

    initialize() {
      this.loadingTable = true

      this.getAll(this.filter)
        .then(response => {
          this.categories = response.data.categories
          this.getHeader()
          this.averageRates = response.data.data
          this.generalAverage = response.data.general_average
          this.generalCount = response.data.general_count
          this.categoryAverages = response.data.category_averages
          this.categoryCounts = response.data.category_counts
          this.dialogFilter = false
        })
        .finally(() => {
          this.loadingTable = false
          this.loadingFilter = false
          this.dialogFilter = false
        })
    },

    periodInitial() {
      const dateToday = new Date()
      dateToday.setHours(dateToday.getHours() - 3)

      this.filter.date_end = dateToday.toISOString().slice(0, 10)

      dateToday.setDate(dateToday.getDate() - 15)

      this.filter.date_start = dateToday.toISOString().slice(0, 10)
    },

    confirmFilter() {
      // validar filtro periodo

      if (!this.filter.date_start) {
        this.error.date_start = 'Campo obrigatório'

        return false
      }
      if (!this.filter.date_end) {
        this.error.date_end = 'Campo obrigatório'

        return false
      }
      this.loadingFilter = true
      this.initialize()
    },

    clearFilter() {
      this.filter = {}
      this.periodInitial()
      this.initialize()
    },

    sendExportPdf() {
      this.isLoading = true
      this.exportPdf(this.filter)
        .then(response => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]))
          const fileLink = document.createElement('a')
          fileLink.href = fileURL
          fileLink.setAttribute('download', 'average_rate_report.pdf')
          document.body.appendChild(fileLink)
          fileLink.click()
          this.isLoading = false
        })
        .finally()
    },

    formatMoney(value) {
      if (value != null) {
        return value.toLocaleString('pt-br', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      }

      return '0,00'
    },

    formatDate(dateTime) {
      if (!dateTime) return null

      const [date, time] = dateTime.split('T')
      const [year, month, day] = date.split('-')

      return `${day}/${month}/${year} `
    },

    getHeader() {
      this.headers = [
        {
          text: 'DATA/CATEGORIA',
          align: 'start',
          sortable: false,
          value: 'date',
        },
      ]
      this.categories.forEach(category => {
        this.headers.push({
          text: category.toUpperCase(),
          align: 'end',
          sortable: false,
          value: category,
        })
      })
      this.headers.push({
        text: 'MÉDIA GERAL',
        align: 'end',
        sortable: false,
        value: 'general',
      })
    },
  },
}
</script>
